import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="19.7499" r="19.6923" fill={fill} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5476 14.694C15.5476 12.9838 17.0075 11.5576 18.8571 11.5576C20.7068 11.5576 22.1667 12.9838 22.1667 14.694V15.4213C22.1667 16.2943 21.7906 17.2758 21.1643 18.0388C20.538 18.8018 19.7155 19.2849 18.8571 19.2849C18.8571 19.2849 18.8571 19.2849 18.8571 19.2849C17.9988 19.2849 17.1762 18.8018 16.55 18.0388C15.9237 17.2758 15.5476 16.2943 15.5476 15.4213V14.694ZM18.8549 20.2849C18.8556 20.2849 18.8564 20.2849 18.8571 20.2849C20.1024 20.2849 21.1846 19.5902 21.9372 18.6733C22.6898 17.7565 23.1667 16.5562 23.1667 15.4213V14.694C23.1667 12.3882 21.2147 10.5576 18.8571 10.5576C16.4995 10.5576 14.5476 12.3882 14.5476 14.694V15.4213C14.5476 16.5562 15.0245 17.7565 15.777 18.6733C16.0101 18.9573 16.2749 19.2199 16.5662 19.4473C15.3044 19.6227 14.2093 19.9128 13.3897 20.1766L13.3892 20.1767C12.266 20.5394 11.5 21.5579 11.5 22.7173V25.6031V26.1031H12H18.0952V25.1031H12.5V22.7173C12.5 22.0105 12.9681 21.3636 13.6962 21.1284C14.9189 20.7349 16.7727 20.2852 18.8549 20.2849Z"
                fill={stroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.4283 27.0577H21.1426V24.8758L25.714 20.5122L27.9997 22.694L23.4283 27.0577Z"
                stroke={stroke}
                strokeLinecap="square"
            />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <g fill="none" fillRule="evenodd" stroke={stroke} transform="translate(1 1)">
                <path d="M5.43507692,7.24676923 C3.72967056,7.24676923 2.21690749,7.63205579 1.22289231,7.96721887 C0.489156923,8.21542072 0,8.90688328 0,9.68168369 L0,12.0779487 L4.83117949,12.0779487" />
                <path
                    strokeLinecap="square"
                    d="M5.43507692,7.24676923 L5.43507692,7.24676923 C3.7677161,7.24676923 2.41558974,5.29074544 2.41558974,3.62338462 L2.41558974,3.01948718 C2.41558974,1.35212636 3.7677161,0 5.43507692,0 L5.43507692,0 C7.10243774,0 8.4545641,1.35212636 8.4545641,3.01948718 L8.4545641,3.62338462 C8.4545641,5.29074544 7.10243774,7.24676923 5.43507692,7.24676923 Z"
                />
                <polygon
                    strokeLinecap="square"
                    points="9.058 13.286 7.247 13.286 7.247 11.474 10.87 7.851 12.682 9.662"
                />
            </g>
        </svg>
    );
};

const MenuProfileEdit = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuProfileEdit.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuProfileEdit;
